'use strict';

/**
 *
 * @name: nownessApp.playerDrawer
 *
 */

import NnPlayerDrawerDirective from './nn-player-drawer.directive';


const PlayerDrawerModule = angular
  .module('nownessApp.playerDrawer', [])
  .directive('nnPlayerDrawer', NnPlayerDrawerDirective);

export default PlayerDrawerModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-player-drawer/nn-player-drawer.module.js